// import CheckByDay from "./components/CheckByDay";
import { uniqueId } from "lodash-es";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React from "react";
import styles from "./style.module.scss";

class ExamResultNhidonghcm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      // bỏ style={{ marginTop: "calc(-7vh)" }} khi code , code xong gắn trở lại
      <div>
        <MDBContainer className={styles.container}>
          <MDBRow className={styles.rowContent}>
            {data.map(item => {
              // eslint-disable-next-line no-unused-expressions
              return (
                <MDBCol key={uniqueId()} xl={12} className={styles.colCalendar}>
                  <h4>{item.date}</h4>
                  {/* <CheckByDay data={data} /> */}
                </MDBCol>
              );
            })}
          </MDBRow>
        </MDBContainer>
      </div>
    );
  }
}

// const mapStateToProps = state => {
//   return {
//     partnerId: state.totalData.partnerId,
//     partnerName: state.hospital.selectedHospital.name
//   };
// };

// const ExamResultNhidonghcmHelmet = withTitle({
//   component: ExamResultNhidonghcm,
//   title: `Trả kết quả`
// });
const data = [
  {
    date: "Đợt khám ngày 05/05/2021",
    list: {
      medical: {
        name: "Đơn thuốc"
      },
      subclinical: {
        name: "Cận lâm sàn"
      }
    }
  },
  {
    date: "Đợt khám ngày 01/03/2021"
  },
  {
    date: "Đợt khám ngày 02/12/2020"
  }
];
export default ExamResultNhidonghcm;
